export default __webpack_public_path__ + "static/media/SRB.a086f440.svg";